import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SupportPingLayer from "../components/SupportPingLayer";

const SupportPing = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Support" />
      <SupportPingLayer />
    </MasterLayout>
  );
};

export default SupportPing;
